var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossPlatformPoker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2398 121.898C36.2398 121.131 36.2398 120.492 36.2398 119.832C36.0906 99.4456 36.0479 79.0596 35.7493 58.6949C35.664 51.793 40.9747 46.9788 47.4797 47.0001C82.5643 47.1492 117.628 47.1492 152.712 47.0001C159.388 46.9788 164.613 52.1339 164.357 58.5671C164.101 64.7446 164.293 70.9222 164.293 77.0998V79.1022C163.568 79.1022 162.971 79.1022 162.395 79.1022C156.039 79.1022 149.684 79.1022 143.328 79.1022C131.022 79.1022 121.637 88.3899 121.531 100.724C121.467 107.519 121.488 114.314 121.531 121.11C121.531 122.303 121.275 122.942 120.102 123.517C118.523 124.284 117.158 125.498 115.665 126.435C115.09 126.797 114.407 127.181 113.789 127.202C104.703 127.245 95.6171 127.245 86.51 127.202C85.8275 127.202 84.9957 126.861 84.4838 126.393C81.114 123.283 77.1897 121.877 72.6255 121.877C61.1936 121.919 49.7618 121.877 38.33 121.877H36.2612L36.2398 121.898Z",
    fill: "url(#paint0_linear_69_587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 121.919C175 128.992 175 136.064 175 143.136C175 149.356 170.351 153.979 164.123 154C157.106 154 150.068 154 143.051 154C136.823 154 132.195 149.356 132.173 143.136C132.173 128.992 132.173 114.868 132.173 100.724C132.173 94.5037 136.823 89.8812 143.051 89.8599C150.068 89.8599 157.106 89.8599 164.123 89.8599C170.351 89.8599 174.979 94.5037 175 100.724C175 107.796 175 114.868 175 121.941V121.919ZM148.255 100.596C148.255 102.556 148.148 104.388 148.276 106.199C148.468 109.01 150.857 111.204 153.565 111.226C156.21 111.247 158.62 109.202 158.876 106.433C159.068 104.537 158.919 102.598 158.919 100.596H148.255Z",
    fill: "url(#paint1_linear_69_587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.581 154C123.749 154 123.301 154 122.853 154C93.8682 154 64.8834 154 35.8986 154C31.3984 154 28.0713 151.891 26.1517 147.886C24.2322 143.924 24.7441 140.068 27.4741 136.618C29.5002 134.04 32.2516 132.634 35.5787 132.634C48.0556 132.634 60.5538 132.634 73.0307 132.613C75.0569 132.613 76.6565 133.38 77.8082 134.913C79.7277 137.448 82.1378 138.13 85.2944 138.066C95.4892 137.853 105.705 138.002 115.9 137.981C117.884 137.981 120.016 138.471 121.275 135.979C121.467 142.177 120.955 148.291 124.602 154.021L124.581 154Z",
    fill: "url(#paint2_linear_69_587)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_587",
    x1: 100.057,
    y1: 47,
    x2: 100.057,
    y2: 127.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_69_587",
    x1: 153.587,
    y1: 89.8599,
    x2: 153.587,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_69_587",
    x1: 74.8018,
    y1: 132.613,
    x2: 74.8018,
    y2: 154.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 107,
    fill: "white",
    transform: "translate(25 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPlatformPoker);
export default __webpack_public_path__ + "static/media/Cross-Platform_Poker.28a82d33c1c16eecb21149cb7855273e.svg";
export { ForwardRef as ReactComponent };